import { EventTypeCode, IFootballConfig, IMainEvent, NameFormat } from '../../../../../packages/types';
import { getIconBasedOnEventType, groupEventsByType } from '../../helpers/main-events';
import { EventIcon } from '../../widgets/Lineups/EventIcons';
import { EventParticipant } from './EventParticipant';
import { useContext } from 'react';
import { ConfigContext } from '@velinsi/smp-widgets-ui';

type MainEventsProps = {
  mainEvents: IMainEvent[];
  dataLabels: IFootballConfig['dataLabels'];
  oddsAvailable: boolean | undefined;
};

export const MainEvents = ({ mainEvents, dataLabels, oddsAvailable }: MainEventsProps) => {
  const { dataNameFormat } = useContext(ConfigContext);

  return (
    <div
      style={{
        width: '100%',
        color: '$secondaryHeaderTextColor',
        fontSize: '12px',
        lineHeight: '20px',
        textAlign: 'center',
        display: 'flex',
        position: 'relative',
        fontFamily: 'var(--fonts-primaryFontFamily)',
        paddingBottom: oddsAvailable ? '16px' : '',
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: '7px',
        gap: '4px',
      }}
    >
      {mainEvents && mainEvents.length > 0 && (
        <>
          {groupEventsByType(mainEvents, dataLabels, dataNameFormat as NameFormat)
            .filter((groupedEvent) => groupedEvent.homePlayers.length > 0 || groupedEvent.awayPlayers.length > 0)
            .map((groupedEvent, index) => (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  fontFamily: 'var(--fonts-primaryFontFamily)',
                  gap: '8px',
                }}
                key={`${groupedEvent.typeCode}-${index}`}
              >
                {/* Home Team */}
                <EventParticipant participantData={groupedEvent.homePlayers} homeTeam />
                {groupedEvent.typeCode === EventTypeCode.GOAL && index === 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      top: '2px',
                    }}
                  >
                    <EventIcon
                      style={{
                        backgroundImage: `url("${getIconBasedOnEventType(EventTypeCode.GOAL)}")`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      top: '2px',
                    }}
                  >
                    <EventIcon
                      style={{
                        backgroundImage: `url("${getIconBasedOnEventType(groupedEvent.typeCode)}")`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }}
                    />
                  </div>
                )}
                {/* Away Team */}
                <EventParticipant participantData={groupedEvent.awayPlayers} homeTeam={false} />
              </div>
            ))}
        </>
      )}
    </div>
  );
};
